import { render, staticRenderFns } from "./WorkloadReport.vue?vue&type=template&id=759ababd&scoped=true&"
import script from "./WorkloadReport.vue?vue&type=script&lang=js&"
export * from "./WorkloadReport.vue?vue&type=script&lang=js&"
import style0 from "./WorkloadReport.vue?vue&type=style&index=0&id=759ababd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759ababd",
  null
  
)

export default component.exports